const relatedAccessoriesMixin = {
    methods: {
        addCartItemRelatedAccessoryToBasket: function (product, index) {
            const vm = this;
            vm.relatedAccessories[index].isAddingToCart = true;

            const data = {
                productId: product.productId,
                quantity: product.quantity
            };

            this.addBasicProductApi(data)
                .then(function (response) {
                    if (!response) {
                        return;
                    }

                    const content = response.data.content;

                    vueShoppingCartCount.total = content.basketItemsTotal;
                    vm.relatedAccessories[index].added = true;
                    vueProduct.quoteMe = content.quoteMe;
                })
                .finally(() => {
                    vm.relatedAccessories[index].added = true;
                    vm.relatedAccessories[index].isAddingToCart = false;
                    vm.triggerAddToCartAnalytics('Add accessory from cart');

                    setTimeout(() => {
                        vm.relatedAccessories[index].added = false;
                        vm.relatedAccessories[index].quantity = 1;
                    }, 5000);
                });
        },
        addRelatedAccessoryToBasket: function (productId) {
            const vm = this;

            const data = {
                productId: productId,
                quantity: 1
            };

            const loader = document.querySelector('#addRelatedAccessoryItemToCart-' + productId);
            loader.classList.remove('d-none');

            this.addBasicProductApi(data)
                .then(function (response) {
                    if (!response) {
                        return;
                    }

                    const content = response.data.content;
                    vueShoppingCartCount.total = content.basketItemsTotal;
                    vueProduct.quoteMe = content.quoteMe;
                    vueAddToCartModal.clearAddedProduct();
                    vueAddToCartModal.open();
                })
                .finally(() => {
                    loader.classList.add('d-none');
                });
        }
    }
}